<template>
  <div class="xinxi">
    <el-table  :data="dataList.list" :show-header="false">
      <el-table-column width="50px" type="index" :index="showIndex" align="right"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" align="left" min-width="100%">
        <template slot-scope="scope">
          <el-button type="text" @click="onClick(scope.row)">{{scope.row.title}}</el-button>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" align="right" min-width="100%">
        <template slot-scope="scope">
          <span style="font-size: 16px">[{{scope.row.createTime.substring(0,10)}}]</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 5px;margin-left: 20px" v-if="name==='detail'" :total="dataList.totalRow" :current-page.sync="dataList.pageNumber" :page-size.sync="dataList.pageSize"
                   layout="total, prev, pager, next, jumper"
                   @current-change="getNews"/>
  </div>
</template>
<script>
import request from "../../../utils/request";
import {getSystemId} from "../../../utils/systemInfo";
import getSystem from "../../../utils/getSystem";

export default {
  name:'projectCollect',
  props:{
    name:{
      type:String,
      required:true
    },
  num:{
    type:Number,
    default: 10
  }
    // status:{
    //   type:String,
    //   required:true
    // }
  },
  data(){
    return{
      page:{
        pageNumber: 1,
        pageSize: 10,
        systemId: getSystemId(),
      },
      dataList:{
        pageNumber: 1,
        pageSize: 10,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
    }
  },
  methods:{
    /**
     * 项目征集列表分页
     */
    async getNews(){
      if(this.page.systemId===''||this.page.systemId===null||this.page.systemId===undefined){
        await getSystem.getSystemInfo()
        this.page.systemId=getSystemId()
      }
      if(this.num !=''){
        this.page.pageSize=this.num
      }
      this.page.pageNumber=this.dataList.pageNumber
      request.post('/portalController/page', this.page).then(rsp => {
        if (rsp.resultCode === '0') {
          this.dataList = rsp.data
        } else {
          this.$message({
            type: 'error',
            message: '项目征集数据加载失败'
          })
        }
      })
    },
    /**
     * 自定义索引
     */
    showIndex(index){
      return index+1+'.'
    },
    onClick(row){
      if(this.name==='page'){
        this.$router.push({path:'/detail',query:{index:'12',id:row.id}})
      }else {
        let param={index:'12',id:row.id}
        this.$emit('listenProject',param)
      }
    }
  },
  mounted(){
    this.getNews()
  }
}
</script>
<style>
.el-table td, .el-table th{
  padding: 0px;
}
.el-table td, .el-table th.is-leaf{
  border-bottom: 0px solid #EBEEF5;
}
</style>



// WEBPACK FOOTER //
// src/views/home/compoment/projectCollect.vue